<div class="dialog-content-wrapper -m-6">
  <mat-toolbar class="mat-primary m-0">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title text-xl text-black m-0">Subscription Status</span>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-dialog-content>
    <div class="p-4 edit-policy-form-modal">
      <p>{{ data.message }}</p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <div class="px-2 ml-auto text-right">
      @if(data.isFreePlan){
        <button mat-raised-button color="primary" aria-label="boards button" (click)="onPlanPurchase()">
          <span>Purchase</span>
        </button>
      }
      @if(!data.isPlanExpired){
        <button mat-raised-button color="primary" aria-label="boards button" (click)="onClose()">
          <span>Cancel</span>
        </button>
      }
    </div>
  </mat-dialog-actions>
</div>
